export const canOrderPaid = (order: any) => {
  if (order) {
    // cena dopravy
    if (order.deliveryTotal === null || order.deliveryTotal === undefined) {
      return false;
    }

    return true;
  }

  return false;
};


// WEBPACK FOOTER //
// ../helpers/src/orders/canOrderPaid.ts